import { IS_BODY_TYPE_REVEALED_CHANGED, INIT_ROOT } from '../actionTypes';

export default (state, { type, payload }) => {
  if (type === INIT_ROOT) {
    return payload.isBodyTypeRevealed;
  }
  if (type === IS_BODY_TYPE_REVEALED_CHANGED) {
    return payload;
  }
  return state || false;
};
